import waterContractTemplate from '@/views/person-center/project/contract-comp/water-contract-template/water-contract-template.vue';
import ProjectService from '@/views/person-center/project/project.service.js';
import Service from '@/service/index.js';
// import RegExpObj from '@/utils/regExp.js';
import { successMessage, errorMessage } from '@/utils/message.js';
export default {
  components: {
    waterContractTemplate
  },
  data() {
    const contractingLimitValidator = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入承包期限'));
      } else if(value <= 0 || value > 30){
        return callback(new Error('承包年限1-30年'));
      } else {
        callback();
      }
    };
    const installmentSumTermValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入分期付款的期数'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const installmentPerYearValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入每期多少年'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else {
        callback();
      }
    };
    const installmentPerYearPriceAddPercentValidator = (rule, value, callback) => {
      if (value === '' || value === null) {
        return callback(new Error('请输入每期承包费递增百分比'));
      } else if(value < 0 || value > 100){
        return callback(new Error('0-100'));
      } else {
        callback();
      }
    };
    const contractEffectivePeriodValidator = (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 100){
        return callback(new Error('1-100'));
      } else {
        callback();
      }
    };
    const afterYearsPayNextPriceValidator =  (rule, value, callback) => {
      if (value === '' || !value) {
        return callback(new Error('请输入'));
      } else if(value <= 0 || value > 10){
        return callback(new Error('1-10'));
      } else if(!this.ruleForm.afterDatePayNextPrice) {
        return callback(new Error('请选择日期'));
      } else {
        callback();
      }
    };
    return {
      // 设置只能选择当前日期及之后的日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      checked: true,
      checked1: false,
      ruleForm: {
        contractingLimit: '', // 承包
        disposalAncillaryFacilities: '',
        sumCurrentPrice: '',
        sumCurrentArea: '',
        contractFeePerYear: 0, // 每年承包费
        remainMoney: 0,
        payType: 1,
        lastPayDate: '', // 剩余交付日期
        inKindOrOtherMethod: '',
        otherMethod: '',
        projectDeposit: '', // 项目定金
        contractDeposit: '',
        paymentContractDepositAgreedDay: '', // 支付合同定金约定
        refundContractDepositAgreedDay: '', // 返还合同定金约定
        lastDeliverDate: '', // 最晚交付日期
        breachMoney: '',
        resolveDisputesWays: '', // 解决争议途径
        floodSeasonAgreement: '',
        bidAllowanceAgreement: '', // 标的补贴
        remainingPriceOfFirstInstallment: '',
        contractEffectivePeriod: '',
        paymentCirculationPriceCycle: '',
        paymentTransferPriceDate: '',
        projectType: '',
        otherAgreement: '',

        installmentSumTerm: '',
        installmentPerYear: '',
        installmentPerYearPriceAddPercent: '',
        installmentPriceOfFirst: '',
        // remainingPriceOfFirstInstallment: '',
        // contractEffectivePeriod: '',
        afterYearsPayNextPrice: '',
        afterDatePayNextPrice: ''
      },
      projectDepositList: [
        {code: 1, 'value': '需要定金'},
        {code: 2, 'value': '不需要定金'}
      ],
      rules: {
        contractingLimit: [
          { required: true, validator: contractingLimitValidator, trigger: 'blur' }
        ],
        disposalAncillaryFacilities: [
          { required: true, message: '请输入附属设施处置方式', trigger: 'blur' }
        ],
        contractFeePerYear: [
          { required: true, message: '请输入每年承包费', trigger: 'blur' }
        ],
        lastPayDate: [
          { required: true, message: '请选择剩余交付日期', trigger: 'blur' }
        ],
        installmentSumTerm: [
          { required: true, validator: installmentSumTermValidator, trigger: 'blur' }
        ],
        installmentPerYear: [
          { required: true, validator: installmentPerYearValidator, trigger: 'blur' }
        ],
        installmentPerYearPriceAddPercent: [
          { required: true, validator: installmentPerYearPriceAddPercentValidator, trigger: 'blur' }
        ],
        installmentPriceOfFirst: [
          { required: true, message: '请输入第一期价款金额', trigger: 'blur' }
        ],
        afterYearsPayNextPrice: [
          { required: true,  validator: afterYearsPayNextPriceValidator, trigger: 'change' }
        ],
        contractEffectivePeriod: [
          { required: true, validator: contractEffectivePeriodValidator, trigger: 'blur' }
        ],
        inKindOrOtherMethod: [
          { required: true, message: '请输入以实物或者实物折资方式', trigger: 'blur' }
        ],
        projectDeposit: [
          { required: true, message: '请选择是否需要项目定金', trigger: 'blur' }
        ],
        contractDeposit: [
          { required: true, message: '请输入合同定金', trigger: 'blur' }
        ],
        paymentContractDepositAgreedDay: [
          { required: true, message: '请输入支付合同定金约定日', trigger: 'blur' }
        ],
        refundContractDepositAgreedDay: [
          { required: true, message: '请输入返还合同定金约定日', trigger: 'blur' }
        ],
        lastDeliverDate: [
          { required: true, message: '请选择最晚交付日期', trigger: 'blur' }
        ],
        breachMoney: [
          { required: true, message: '请输入违约金', trigger: 'blur' }
        ],
        resolveDisputesWays: [
          { required: true, message: '请选择解决争议途径', trigger: 'blur' }
        ],
        floodSeasonAgreement: [
          { required: true, message: '请输入季节灌溉、汛期放水等约定', trigger: 'blur' }
        ],
        bidAllowanceAgreement: [
          { required: true, message: '请输入标的各种补贴约定', trigger: 'blur' }
        ],
        // contractEffectivePeriod: [
        //   { required: true, message: '请输入合同生效后多少天支付第一期剩余价款', trigger: 'blur' }
        // ],
        paymentCirculationPriceCycle: [
          { required: true, message: '请输入支付承包费周期', trigger: 'blur' }
        ],
        paymentTransferPriceDate: [
          { required: true, message: '请输入支付流转价款日期', trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      createContractInfo: {
        // projectAssets: {}
      },
      disputeWay: null, // 争议解决途径
      contractPeriod: null, // 承包期限
      previewContract: null, // 预览合同的信息
      massifType: null // 地块类型
    };
  },
  created() {
    // console.log(this.type, '瑕疵声明及重大事项提示');
    this.ruleForm.userId = this.$route.query.userId;
    this.ruleForm.projectId = this.$route.query.id;
    this.ruleForm.projectType = this.$route.query.projectType;
    this.getDictList();
  },
  watch: {
    'ruleForm.installmentPriceOfFirst'(newName, oldName) {
      if(newName !== oldName) {
        this.ruleForm.remainingPriceOfFirstInstallment = this.ruleForm.installmentPriceOfFirst - (this.createContractInfo.marginSubServiceFee);
      }
    }
  },
  computed: {
  },
  mounted() {
    this.getContractData();
  },
  methods: {
    installmentPriceOfFirstValidator(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请输入第一期价款金额'));
      } else if(value < this.createContractInfo.marginSubServiceFee){
        return callback(new Error('不能小于竞价保证金-服务费'));
      } else {
        callback();
      }
    },
    change(){
      this.$forceUpdate();
    },
    // 计算承包年限
    datedifference(sDate1, sDate2) { // sDate1和sDate2是2006-12-18格式
      var dateSpan, iDays;
      sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = (dateSpan / (24 * 3600 * 1000)) / 365;
      var y = String(iDays).indexOf('.') + 1; // 获取小数点的位置
      console.log(iDays, String(iDays).split('.'), 'iDays.split');
      if(y > 0) {
        if(String(iDays).split('.')[0] === '0') {
          return iDays = iDays.toFixed(0);
        } else {
          return iDays = iDays.toFixed(1);
        }
      } else {
        return iDays;
      }
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        DISPUTE_RESOLUTION_WAY: 'disputeWay',
        CONTRACT_PERIOD: 'contractPeriod',
        MASSIF_TYPE: 'massifType'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
          }
        });
      });
    },
    // 数据回显
    getContractData() {
      ProjectService.toCreateContract(this.ruleForm.projectId, this.ruleForm.userId, this.ruleForm.projectType).then(res => {
        if (res && res.code === '0') {
          this.createContractInfo = {
            ...res.data
          };
          for (let key in this.createContractInfo) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = this.createContractInfo[key];
            }
            // 第一期价款金额如果小于0 则等于0
            if(res.data.installmentPriceOfFirst < 0) {
              this.createContractInfo.installmentPriceOfFirst = 0;
            }
            // 其他途径复选
            if(key === 'resolveDisputesWays' && res.data.resolveDisputesWays) {
              this.ruleForm.resolveDisputesWays = String(this.ruleForm.resolveDisputesWays);
              this.checked1 = true;
            }

            if(key === 'remainingPriceOfFirstInstallment') {
              if(!res.data.remainingPriceOfFirstInstallment) {
                this.ruleForm.remainingPriceOfFirstInstallment = this.createContractInfo.installmentPriceOfFirst - this.createContractInfo.marginSubServiceFee;
              }
            }
          }
          // this.createContractInfo.startTime = '2021-01-26T16:00:00.000+0000';
          // this.createContractInfo.endTime = '2024-12-26T16:00:00.000+0000';
          this.ruleForm.contractingLimit = this.datedifference(this.createContractInfo.startTime, this.createContractInfo.endTime);
          if(!this.ruleForm.contractFeePerYear) {
            this.handler();
          }
        }
      });
    },
    // 计算每年承包费
    handler() {
      if(this.createContractInfo.sumCurrentPrice > 0 && this.createContractInfo.sumCurrentArea > 0 && Number(this.createContractInfo.deliveryPeriod) > 0) {
        this.ruleForm.contractFeePerYear = (this.createContractInfo.sumCurrentPrice/this.createContractInfo.sumCurrentArea/Number(this.createContractInfo.deliveryPeriod)).toFixed(2);
      } else {
        this.ruleForm.contractFeePerYear = 0;
      }
    },
    previousStep () {
      this.$router.back();
    },
    // 预览合同
    previewBtn() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.submit(false);
        } else {
          return false;
        }
      });
    },
    // 立即提交
    test() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交合同信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit(true);
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 确认提交按钮
    submit(isSave) {
      // 保存接口传参
      ProjectService.createContract({
        isSave: isSave,
        ...this.ruleForm
      }).then(res => {
        if(isSave) {
          if (res && res.code === '0') {
            successMessage('创建成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('创建失败');
          }
        } else {
          ProjectService.displayWoodsContract(
            this.ruleForm.projectId,
            this.ruleForm.projectType,
            this.ruleForm.userId,
            '1'
          ).then(res => {
            if (res && res.code === '0') {
              this.previewContract = res.data;
              // this.getContractData();
            }
          });
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('创建失败');
        }
      });
    }
  }
};
